import { combineReducers } from "redux";
import ReducerParams, { ParamsState } from "./params.reducer";

/**
 * Interface du state des scenarios
 *
 * @export
 * @interface ScenarioState
 */
export interface ScenarioState {
  params: ParamsState;
}

/**
 * on combine la totalité des reducers de scenario
 */
export default combineReducers<ScenarioState>({
  params: ReducerParams
});
